import type { FC } from "react"
import styles from "./Message.module.scss"
import { Icon } from "Components/UI"

interface PromptCardProps {
  icon: "calendar" | "disciplinaArquitetura" | "relogio" | "alerta" 
  title: string
  description: string
  onClick: () => void
}

export const PromptCard: FC<PromptCardProps> = ({ icon, title, description, onClick }) => {
  return (
    <div className={styles["MessageContainer"]} onClick={onClick}>
      <div className={styles["content"]}>
        <div className={styles["icon-container"]}>
          <Icon icon={icon} size="md" style={{ color: '#8697A8', fill: 'currentColor' }} />
        </div>
        <h2 className={styles["title"]}>{title}</h2>
      </div>
      <p className={styles["description"]}>{description}</p>
    </div>
  )
}